import { apiFetch } from "./client";

export interface ContactInitResponse {
  status?: string;
  csrf_token?: string;
  user?: { name?: string; email?: string };
}

export interface ContactSubmitFields {
  name: string;
  email: string;
  topic: string;
  message: string;
  csrf_token: string;
  recaptcha_token: string;
}

export class ContactSubmitError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly body: { error?: string; csrf_token?: string },
  ) {
    super(message);
    this.name = "ContactSubmitError";
  }
}

/** GET /contact — CSRF token + optional logged-in user prefill. */
export async function fetchContactInit(): Promise<ContactInitResponse> {
  const res = await apiFetch("/contact", { method: "GET" });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  return (await res.json()) as ContactInitResponse;
}

/**
 * POST /contact as `multipart/form-data` — matches Tornado `get_argument`
 * (not JSON).
 */
export async function submitContactForm(
  fields: ContactSubmitFields,
): Promise<{ status?: string }> {
  const fd = new FormData();
  fd.append("name", fields.name);
  fd.append("email", fields.email);
  fd.append("topic", fields.topic);
  fd.append("message", fields.message);
  fd.append("csrf_token", fields.csrf_token);
  fd.append("recaptcha_token", fields.recaptcha_token);

  const res = await apiFetch("/contact", { method: "POST", body: fd });
  let body: { error?: string; csrf_token?: string; status?: string } = {};
  try {
    body = (await res.json()) as typeof body;
  } catch {
    /* ignore */
  }

  if (!res.ok) {
    throw new ContactSubmitError(
      body.error || `HTTP ${res.status}`,
      res.status,
      body,
    );
  }
  return body;
}
